import { Component, OnInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { Router, ActivatedRoute } from '@angular/router';
import { ViewEncapsulation } from '@angular/core';
import { BREADCRUMBS } from 'config';
import { FaqService } from './faq.service';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';
import {Subscription} from "rxjs";
import { AuthenticationService } from 'lib/ng2-sapmp/src/providers/authentication.service';
import { ProductSelectionService } from '../product-selection/product-selection.service';

@Component({
  selector: 'app-faq',
  providers: [FaqService, ProductSelectionService],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FaqComponent implements OnInit {
  faqDetails: any;
  overviewModalPopup: ConfirmModalPopupModel;
  url: any;
  isTask: boolean;
  modalClass: string;
  showOverviewModal: boolean;
  question: Number;
  isOpen: boolean;
  showEnrollLink: boolean = true;
  showABMAnswer: boolean = false;
  isABMFE: boolean = false;
  showABMFEOption: boolean = false;
  fanInfoList: any;
  fanInfoListString: any;
  fanInfoListArr: any;
  accountStatus: string;
  public enrollStatusSubscription: Subscription;
  @ViewChild('target') elRef;
  // faqHeadings = ["General Information", "About Samsung Knox Mobile Enrollment (KME)", "About Android™ zero-touch", "About Apple Business(ABM)", "About Enterprise Firmware Over the Air (E-FOTA)"];
  faqHeadings = ["General Information", "About Android Programs", "About Apple Business", "About Enterprise Firmware Over the Air (E-FOTA)"];
  generalFaq = [];
  samsungFaq = [];
  androidFaq = [];
  abmFaq = [];
  efotaFaq = [];
  callingPage: String;
  constructor(private breadCrumbService: BreadCrumbService,
    private faqservice: FaqService,
    private chips: ChipsService,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private authenticationService: AuthenticationService,
    private productSelectionService: ProductSelectionService,
    // route: ActivatedRoute,
    private router: Router,
    private utilityService: UtilityService) {
    this.faqDetails = [];
    this.question = route.snapshot.queryParams.id;
    this.isOpen = false; 
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.callingPage = sessionStorage.getItem('callingPageName');
    sessionStorage.setItem('callingPageName', '');
    if (this.callingPage === 'support') {
      this.chips.setChips([
        {
          "label" : "Home",
          "routerLink" : "/home"
      }, 
      {
          "label" : "Support",
          "routerLink" : "/support"
      }, 
      {
          "label" : 'Frequently asked questions',
          "routerLink" : "/faq"
      }] );
     } else {
      this.chips.setChips([
        {
          "label" : "Home",
          "routerLink" : "/home"
      }, 
      {
          "label" : 'Frequently asked questions',
          "routerLink" : "/faq"
      }]) 
      }
    this.faqservice.getFaqDetails().subscribe(response => {
      console.log(response);
      this.faqDetails = response;
    this.generalFaq = this.faqDetails.faqs.filter(el => el.category == "General");
    this.samsungFaq = this.faqDetails.faqs.filter(el => el.category == "Samsung");
    this.androidFaq = this.faqDetails.faqs.filter(el => el.category == "Android");
    this.abmFaq = this.faqDetails.faqs.filter(el => el.category == "ABM");
    this.efotaFaq = this.faqDetails.faqs.filter(el => el.category == "E-FOTA");
      this.faqDetails.faqs.map(function (faqs) {
        faqs.category = faqs.question;
        faqs.ariaLabel = {
          'expand': 'Show FAQ',
          'collapse': 'Hide FAQ',
        };
        setTimeout(() => {
          //  this.openAccordion();
        }, 1000);
      });
    });
    this.faqservice.createPageLoadProperties();
    this.enrollStatusSubscription = this.authenticationService.getEnrollStatus().subscribe(status => {
      this.showEnrollLink = status;
    });
    
    this.fanInfoList = sessionStorage.getItem('fanInfoList');
    this.fanInfoListString = sessionStorage.getItem('fanInfoList');
    if(this.fanInfoListString === 'undefined' || this.fanInfoListString === null) {
      this.showABMAnswer = true;
    }
     else if (this.fanInfoListString !== 'undefined' && this.fanInfoListString !== null) {
     this.fanInfoListArr = JSON.parse(this.fanInfoListString);
     let hasDMPAABM = false;  
        for (let item of this.fanInfoListArr) {
          if (item.emmProductCode === 'DMPAABM') {
            hasDMPAABM = true;
            this.accountStatus = item.accountStatus;
            if(this.accountStatus === 'SIGNUP_INPROGRESS' || this.accountStatus === 'REMOVE_INPROGRESS' || this.accountStatus === 'PROCESSING' || this.accountStatus === 'ACTIVE' || this.accountStatus === 'INACTIVE') {
            this.showABMFEOption = false;
            } else {
                this.showABMFEOption = true
              }
          }
          if (!hasDMPAABM) {
            this.showABMFEOption = true;
          }
        }
    } else {
      this.showABMFEOption = true;
    }

    if(this.showEnrollLink && !this.showABMFEOption) {
      this.showABMAnswer = true;
    } else if(!this.showEnrollLink && !this.showABMFEOption) {
      this.showABMAnswer = true;
    }

    if(this.showABMFEOption && this.showEnrollLink) {
      sessionStorage.setItem('ABMApply', 'true');
    }
  }
  // ngAfterContentChecked() {
  //   this.openAccordion();
  // }
  // openAccordion() {
  //   if (this.elRef && this.elRef.el && this.elRef.el.nativeElement && this.question && !this.isOpen) {
  //     let el = <HTMLElement>document.querySelector(" [id='9'] .toggle-header");
  //     el.click();
  //     el.scrollIntoView();
  //     this.isOpen = true;
  //   }
  // }

  initOverviewModal() {
    this.overviewModalPopup = new ConfirmModalPopupModel();
    this.overviewModalPopup.modalMessage = '';
    this.overviewModalPopup.modalSubHeader = 'Overview Tutorial';
    this.overviewModalPopup.modalHeader = 'Modal Header';
    this.overviewModalPopup.confirmButtonMessage = 'OK';
    this.overviewModalPopup.showCancelButton = false;
    this.modalClass = 'modal-lg';
  }

  openOverviewModal(url, isTask) {
    this.showOverviewModal = true;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.isTask = isTask;
  }

  closeOverviewModal() {
    this.showOverviewModal = false;
  }
}


